(() => {
  const script = document.currentScript;
  const moduleUrl = script && script.dataset.configuratorModule;
  const cartUrl = script && script.dataset.cartUrl;
  const openCartPage = () => {
    if (cartUrl && window.location.hash === '#cesta-metraink') {
      window.location.replace(cartUrl);
      return true;
    }
    return false;
  };
  window.addEventListener('hashchange', openCartPage);
  if (openCartPage()) return;
  document.addEventListener('click', (event) => {
    if (!cartUrl || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest?.('a');
    if (!anchor || new URL(anchor.href, document.baseURI).href !== new URL(cartUrl, document.baseURI).href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(cartUrl);
  }, true);

  const showStatus = (message, detail) => {
    document.querySelectorAll("[data-metraink-configurator]").forEach((root) => {
      if (root.dataset.mounted === "true") return;
      const status = root.querySelector(".metraink-configurator-app__status strong");
      const description = root.querySelector(":scope > p");
      if (status) status.textContent = message;
      if (description && detail) description.textContent = detail;
    });
  };

  const start = async () => {
    if (!document.querySelector('[data-metraink-configurator]')) return;
    if (!moduleUrl) {
      showStatus("No se encontró el módulo", "Shopify no ha generado la dirección del configurador.");
      return;
    }

    try {
      await import(new URL(moduleUrl, document.baseURI).href);
      window.setTimeout(() => {
        const pending = document.querySelector("[data-metraink-configurator]:not([data-mounted='true'])");
        if (pending) {
          showStatus("El archivo cargó, pero no se inició", "La calculadora no encontró su contenedor. Recarga la página para volver a intentarlo.");
        }
      }, 250);
    } catch (error) {
      const detail = error instanceof Error ? error.message : String(error);
      showStatus("Error al iniciar la calculadora", detail.slice(0, 220));
      console.error("Metraink configurator boot error", error);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
